import React from "react";
import useDebugInformation from "../../hooks/useDebugInformation";

const name = "TabPanel"

type TabPanelProps = {
    children: any
    value: any
    index: number
    parent: string
    style?: React.CSSProperties
}

const TabPanel: React.FC<TabPanelProps> = ({ parent, children, value, index, style }) => {
    const memoProps = React.useMemo(() => ({ children }), [children])

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { memoProps })
    return (
        <div
            role="tabpanel"
            style={{ marginTop: 12, ...style }}
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
        >
            {value === index ? <div style={{ width: 510, marginLeft: "10px" }}>{children}</div> : null}
        </div>
    )
}

export default React.memo(TabPanel)